import React, { useEffect } from 'react';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import AccountAdminInfo from './AccountAdminInfo';
import BusinessOwnerInfo from './BusinessOwnerInfo';
import OrganizationImages from './OrganizationImages';
import PaymentStep from './PaymentStep';
import SmsCampaignOptIn from './SmsCampaignOptIn';
import FinalAccountCreation from './FinalAccountCreation';

const STEPS = [1, 2, 3, 4, 5, 6];

export default function NewAccountFlow() {
  const history = useHistory();
  const { stepNum } = useParams();
  const step = stepNum ? parseInt(stepNum, 10) : 1;

  const hasStep1Data = typeof sessionStorage !== 'undefined'
    && !!sessionStorage.getItem('newAccount_step1');

  useEffect(() => {
    if (step >= 2 && step <= 5 && !hasStep1Data) {
      history.replace('/new-account/step/1');
    }
  }, [step, hasStep1Data, history]);

  const hasPaymentToken = typeof sessionStorage !== 'undefined'
    && !!sessionStorage.getItem('newAccount_paymentToken');
  useEffect(() => {
    if (step === 6 && !hasPaymentToken) {
      history.replace('/new-account/step/1');
    }
  }, [step, hasPaymentToken, history]);

  if (!STEPS.includes(step)) {
    return <Redirect to="/new-account/step/1" />;
  }

  if (step >= 2 && step <= 5 && !hasStep1Data) {
    return null;
  }

  switch (step) {
  case 1:
    return <AccountAdminInfo />;
  case 2:
    return <BusinessOwnerInfo />;
  case 3:
    return <OrganizationImages />;
  case 4:
    return <SmsCampaignOptIn />;
  case 5:
    return <PaymentStep />;
  case 6:
    return <FinalAccountCreation />;
  default:
    return <Redirect to="/new-account/step/1" />;
  }
}
